import React from "react";

const ExportIcon16pxSvg = ({
    color = "#1F2937",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M10.1733 14.8334H5.82665C2.55332 14.8334 1.15332 13.4334 1.15332 10.1601V10.0734C1.15332 7.11343 2.31999 5.68677 4.93332 5.4401C5.19999 5.4201 5.45332 5.6201 5.47999 5.89343C5.50665 6.16677 5.30665 6.41343 5.02665 6.4401C2.93332 6.63343 2.15332 7.6201 2.15332 10.0801V10.1668C2.15332 12.8801 3.11332 13.8401 5.82665 13.8401H10.1733C12.8867 13.8401 13.8467 12.8801 13.8467 10.1668V10.0801C13.8467 7.60677 13.0533 6.6201 10.92 6.4401C10.6467 6.41343 10.44 6.17343 10.4667 5.9001C10.4933 5.62677 10.7267 5.4201 11.0067 5.44677C13.66 5.67343 14.8467 7.10677 14.8467 10.0868V10.1734C14.8467 13.4334 13.4467 14.8334 10.1733 14.8334Z" fill={color} />
            <path d="M8 10.5C7.72667 10.5 7.5 10.2733 7.5 10V2.41333C7.5 2.14 7.72667 1.91333 8 1.91333C8.27333 1.91333 8.5 2.14 8.5 2.41333V10C8.5 10.2733 8.27333 10.5 8 10.5Z" fill={color} />
            <path d="M10.2333 4.39988C10.1066 4.39988 9.97998 4.35321 9.87998 4.25321L7.99998 2.37321L6.11998 4.25321C5.92664 4.44655 5.60664 4.44655 5.41331 4.25321C5.21998 4.05988 5.21998 3.73988 5.41331 3.54655L7.64664 1.31321C7.83998 1.11988 8.15998 1.11988 8.35331 1.31321L10.5866 3.54655C10.78 3.73988 10.78 4.05988 10.5866 4.25321C10.4933 4.35321 10.36 4.39988 10.2333 4.39988Z" fill={color} />
        </svg>
    );
};

export default ExportIcon16pxSvg;